import { AfterViewInit, Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { LoadSimulationService } from '../load-simulation.service';

@Component({
    selector: 'app-load-simulation-table',
    templateUrl: './load-simulation-table.component.html',
    styleUrls: ['./load-simulation-table.component.css']
})
// --- Component Description ---
// Table component for displaying and selecting simulations. Handles row click/double-click and subscribes to filtered simulations.
export class LoadSimulationTableComponent implements OnInit, AfterViewInit {
    @ViewChild(DataTableDirective) dtElement: DataTableDirective;
    dtOptions: DataTables.Settings = {
        pagingType: 'simple_numbers',
        pageLength: 25,
        lengthMenu: [[5, 10, 25], [5, 10, 25]],
        order: [[0, 'asc']],
        autoWidth: false,
        language: {
            emptyTable: 'No simulations found',
        }
    };
    dtTrigger: Subject<any> = new Subject<any>();
    isDtInitialized = false;

    simulations: any[] = [];
    selectedSimulation: any = null;
    clickTimeout: any = null;

    @Output() loadSimulationEvent = new EventEmitter<any>();

    // --- Private Properties ---
    private filteredSimulationsSub: any;

    constructor(private loadSimulationService: LoadSimulationService) { }

    ngOnInit(): void {
        this.filteredSimulationsSub = this.loadSimulationService.filteredSimulations$.subscribe(simulations => {
            this.simulations = simulations;
            this.selectedSimulation = null;
            this.loadSimulationService.setSelectedSimulation(null);
            if (this.isDtInitialized && this.dtElement) {
                this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                    dtInstance.destroy();
                    this.dtTrigger.next();
                });
            }
        });
    }

    onRowClick(sim: any) {
        if (this.clickTimeout) {
            clearTimeout(this.clickTimeout);
            this.clickTimeout = null;
        }
        this.clickTimeout = setTimeout(() => {
            this.selectedSimulation = sim;
            this.loadSimulationService.setSelectedSimulation(sim);
            this.clickTimeout = null;
        }, 200);
    }

    onRowDblClick(sim: any) {
        if (this.clickTimeout) {
            clearTimeout(this.clickTimeout);
            this.clickTimeout = null;
        }
        this.selectedSimulation = sim;
        this.loadSimulation(sim);
    }

    loadSimulation(sim?: any): void {
        this.loadSimulationEvent.emit(sim || this.selectedSimulation);
    }

    ngAfterViewInit(): void {
        this.isDtInitialized = true;
        this.dtTrigger.next();

        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.on('page.dt length.dt', () => {
                setTimeout(() => {
                    this.selectedSimulation = null;
                    this.loadSimulationService.setSelectedSimulation(null);
                }, 0);
            });
        });
    }

    ngOnDestroy(): void {
        if (this.filteredSimulationsSub) {
            this.filteredSimulationsSub.unsubscribe();
        }
        this.dtTrigger.unsubscribe();
    }
}
